@if (isAuthenticated$ | async) {
  @if (itemsLogged$ | async; as itemsLogged) {
    <div class="header-user-info">
      <p-menubar [model]="itemsLogged"></p-menubar>
    </div>
  }

} @else if (!isLoginPage()) {
  <app-button
    [label]="'menu.authenticate' | translate"
    severity="secondary"
    routerLink="/login"
    icon="icon-lock1"
  ></app-button>
}
